import { apiService } from './index';
import { TOKEN } from '../contexts/authContext';

export type BulkUploadResult = { name: string; url: string };

export const asyncPostFilesBulk = async (
  files: File[]
): Promise<{ items: BulkUploadResult[] }> => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));

  return await apiService.post('/api/files/bulk', formData, undefined, {
    accept: '*/*',
    Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
  });
};

export const chunkArray = <T,>(arr: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};